/**
 * Utilidades para decodificar JWT en el cliente.
 *
 * El payload de un JWT viene en base64url y su contenido está codificado en UTF-8.
 * `atob` decodifica base64 a una cadena binaria (Latin-1), por lo que los
 * caracteres multibyte (ej. tildes, "ñ") se rompen (mojibake: "ú" -> "Ã º").
 * Por eso se reinterpretan los bytes como UTF-8 antes de parsear el JSON.
 */

const base64UrlToJson = (base64Url) => {
  // base64url -> base64
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(base64);

  // Reinterpretar los bytes como UTF-8
  const percentEncoded = Array.prototype.map
    .call(binary, (char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
    .join('');
  const json = decodeURIComponent(percentEncoded);

  return JSON.parse(json);
};

/**
 * Decodifica el payload de un JWT respetando la codificación UTF-8.
 * @param {string} token JWT completo (header.payload.signature)
 * @returns {object} payload decodificado, o {} si el token es inválido
 */
export const decodeJwt = (token) => {
  try {
    if (!token) return {};
    const parts = token.split('.');
    if (parts.length !== 3) return {};
    return base64UrlToJson(parts[1]);
  } catch (e) {
    console.error('Error decoding JWT', e);
    return {};
  }
};

export default decodeJwt;
